import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Other Achievements|Add Other Achievements`;

const sharedLocProps: { htmlAllowed: boolean; feature: HubFeature; portal: LocPortal; shared: boolean } = {
	htmlAllowed: false,
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	portal: 'CP',
	shared: false,
};
export type CPOtherAchievementsAddPage = 'CPOtherAchievementsAddSectionTitle';

export const cpOtherAchievementAddLocs: LocDefs<CPOtherAchievementsAddPage> = {
	CPOtherAchievementsAddSectionTitle: {
		...sharedLocProps,
		defaultValue: 'Add Industry Certification',
		description: 'Title for the other achievements add section.',
		displayPath: `${dpRoot}|Page section Title`,
		displayType: 'Title',
	},
};

export const LOC_KEYS = MapLocKeys<CPOtherAchievementsAddPage>(cpOtherAchievementAddLocs);
export type CPOtherAchievementsAddLocType = LocMap<CPOtherAchievementsAddPage>;
